import React, { useEffect, useState } from "react";
import {
  BoxContainer,
  BoxHead,
  BoxTitle,
  Underline,
} from "../../Components/Styles/PageStyles";
import ProductReport from "../../Components/Reports/Report";
import Table from "../../Components/Reports/Table";
import tw from "tailwind-styled-components";
import NotFoundModel from "../../Components/NotFoundModel";
import { useMutation } from "react-query";
import axios from "axios";
import { useSelector } from "react-redux";
import Config from "../../Config";
import Loading from "../../Components/Loading";

const Reports = () => {
  const [filterType, setFilterType] = useState("1");
  const [apiData, setApiData] = useState();
  const user = useSelector((state) => state.UserReducer.user);
  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/report/list`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.reportList);
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  return (
    <BoxContainer className="!h-auto">
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Reports
          <Underline />
        </BoxTitle>
      </BoxHead>
      {!error && !isLoading && data && (
        <>
          <ButtonGroup>
            <TemplateButton
              isActive={filterType === "1"}
              onClick={() => setFilterType("1")}
            >
              Category
            </TemplateButton>
            <TemplateButton
              ml
              isActive={filterType === "2"}
              onClick={() => setFilterType("2")}
            >
              Downloads
            </TemplateButton>
          </ButtonGroup>
          <Seperator />
          {filterType === "1" ? (
            <ProductReport />
          ) : (
            <TableWrapper>
              <Table apiData={error ? [] : apiData} />
              {apiData.length === 0 && !isLoading && <NotFoundModel />}
            </TableWrapper>
          )}
        </>
      )}
      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};
const ButtonGroup = tw.div`flex items-center !gap-0`;
const TemplateButton = tw.button`
  px-2 font-semibold relative ${(props) =>
    props.isActive ? "text-primary-color" : "text-gray-600"}
  ${(props) => (props.ml ? "ml-2" : "")}
  after:absolute after:top-8 after:left-0 after:w-full after:h-0.5
  ${(props) => (props.isActive ? "after:bg-blue-500" : "")}
`;
const Seperator = tw.div`w-full h-[0.090rem] bg-gray-200 mt-2 `;
const TableWrapper = tw.h1`mt-8 border bg-white rounded-md`;
export default Reports;


// import React, { useEffect, useState } from "react";
// import {
//   BoxContainer,
//   BoxHead,
//   BoxTitle,
//   Underline,
// } from "../../Components/Styles/PageStyles";
// import ProductReport from "../../Components/Reports/Report";
// import Table from "../../Components/Reports/Table";
// import tw from "tailwind-styled-components";
// import NotFoundModel from "../../Components/NotFoundModel";
// import { useMutation } from "react-query";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import Config from "../../Config";
// import Loading from "../../Components/Loading";

// const Reports = () => {
//   const [filterType, setFilterType] = useState("1");
//   const [apiData, setApiData] = useState([]); //  start with empty array
//   const user = useSelector((state) => state.UserReducer.user);

//   const fetchFunction = async () => {
//     const response = await axios.get(`${Config.apiUrl}/report/list`, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//     return response.data;
//   };

//   const getSuccess = (res) => {
//     if (res?.isSuccess) {
//       setApiData(res?.reportList || []);
//     } else {
//       setApiData([]);
//     }
//   };

//   const getError = () => {
//     setApiData([]);
//   };

//   const {
//     isLoading,
//     mutate: getListMutate,
//     error,
//     isRefetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//     onError: getError,
//   });

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       getListMutate();
//     }, 500);

//     return () => clearTimeout(handler);
//   }, []);

//   return (
//     <BoxContainer className="!h-auto">
//       <BoxHead>
//         <BoxTitle className="!mb-0 whitespace-nowrap">
//           Reports
//           <Underline />
//         </BoxTitle>
//       </BoxHead>

//       {/* Loading */}
//       {(isLoading || isRefetching) && <Loading />}

//       {/* Main Content */}
//       {!isLoading && (
//         <>
//           <ButtonGroup>
//             <TemplateButton
//               isActive={filterType === "1"}
//               onClick={() => setFilterType("1")}
//             >
//               Category
//             </TemplateButton>

//             <TemplateButton
//               ml
//               isActive={filterType === "2"}
//               onClick={() => setFilterType("2")}
//             >
//               Downloads
//             </TemplateButton>
//           </ButtonGroup>

//           <Seperator />

//           {filterType === "1" ? (
//             <ProductReport />
//           ) : (
//             <TableWrapper>
//               <Table apiData={apiData} />
//               {apiData.length === 0 && !error && <NotFoundModel />}
//             </TableWrapper>
//           )}

//           {/* API error */}
//           {error && <NotFoundModel />}
//         </>
//       )}
//     </BoxContainer>
//   );
// };

// const ButtonGroup = tw.div`flex items-center !gap-0`;

// const TemplateButton = tw.button`
//   px-2 font-semibold relative ${(props) =>
//     props.isActive ? "text-primary-color" : "text-gray-600"}
//   ${(props) => (props.ml ? "ml-2" : "")}
//   after:absolute after:top-8 after:left-0 after:w-full after:h-0.5
//   ${(props) => (props.isActive ? "after:bg-blue-500" : "")}
// `;

// const Seperator = tw.div`w-full h-[0.090rem] bg-gray-200 mt-2`;
// const TableWrapper = tw.h1`mt-8 border bg-white rounded-md`;

// export default Reports;
